/**
 * Whether the browser will render this file in a frame rather than save it.
 *
 * PDFs and images it displays; Word documents it downloads, no matter what
 * `Content-Disposition` the bucket sends. Framing one of those is what made
 * "open" behave as "download" — the viewer asks this first and offers the file
 * explicitly instead.
 *
 * Read from the URL because the stored document carries no MIME type: the file
 * a user picked is passed to the presign step and never persisted. The upload
 * key keeps the original extension (`guessExtension` in documents-service), so
 * it is the only thing available without a migration. Query strings are
 * stripped first — presigned links carry them.
 */
// No HEIC/HEIF here although uploads accept them: only Safari renders HEIC,
// so on every other browser framing one downloads the file — the exact
// behaviour this module exists to prevent. iPhone photos are HEIC by default,
// which makes that the common case, not the edge.
const PREVIEWABLE_EXTENSIONS = [
	'.pdf',
	'.jpg', '.jpeg', '.png', '.webp',
] as const

export function canPreviewInBrowser(fileUrl: string | undefined): boolean {
	if (!fileUrl) return false

	const path = fileUrl.split(/[?#]/)[0].toLowerCase()
	return PREVIEWABLE_EXTENSIONS.some((ext) => path.endsWith(ext))
}
